import '@/Infrastructure/ServiceRegistry.ts';

import RADApplication from "@/Management/RADApplication";
import Loader from "@/Utility/Loader";
import ComponentManager from "@/Management/ComponentManager";
import FrontController from "@/Management/FrontController";
import initKnockoutCustomizations from "@/Infrastructure/KnockoutCustomization";
import initKnockoutCustomExtenders from "@/Infrastructure/CustomExtenders";
import initCustomBindings from "@/Infrastructure/CustomBindings";
'use strict';

// (T)KO options
(ko.options as any).createChildContextWithAs = true;
(ko.options as any).useOnlyNativeEvents = true;
(ko.options as any).templateSizeLimit = 0;
(ko.options as any).disableJQueryUsage = true;
// wir verwenden teils Bindings der Art data-bind="if: value() != null"
// wenn die option strictEquality true ist (standard) würde intern !== verwendet
(ko.options as any).strictEquality = false;

initKnockoutCustomizations();
initKnockoutCustomExtenders();
initCustomBindings();


function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}

// Unit-Test
window.testModeEnabled = false;
window.enableTestMode = () => {
    if (window.testModeEnabled)
        return;

    jQuery('body').addClass('unittestmode');
    window.testModeEnabled = true;
};

// Anwendungsstart einleiten, sobald DOM vorhanden
$(async () => {
    checkBrowserRequirements();

    const loader = Loader.getInstance();
    loader.init();
    loader.show();

    await ComponentManager.init();

    RADApplication.getInstance().init();
    FrontController.init();

    loader.hide();
});

function checkBrowserRequirements() {
    // Browser-Vorraussetzungen prüfen
    const errors = [];
    const body = $('body');

    const isIE = detectIE();
    if (isIE) {

        const requirements = {
            localstorage: {
                name: 'LocalStorage',
                description: 'Lokales Speichern von benutzersepezifischen Einstellungen.'
            },
            csscalc: {
                name: 'CSS Calc',
                description: 'Breiten-/Höhenberechnung auf Basis von Prozent- und Pixelwerten.'
            },
            flexbox: {
                name: 'CSS FlexBox',
                description: 'Berechnet Breiten und Höhen von Factories in Layouts.'
            }
        };

        for (const requirement in requirements) {
            errors.push(requirements[requirement]);
        }
    }

    if (errors.length > 0) {
        const container = $('<div class="c-requirement-error"></div>').prependTo(body);
        $('<h1>Hinweis zur Browserkompatibilität</h1>').appendTo(container);
        $('<h2>Folgende Funktionen werden von Ihrem Browser nicht unterstützt:</h2>').appendTo(container);

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            container.append('<span class="c-requirement"><strong>' + error.name + '</strong>: ' + error.description + '</span>');
        }

        $('<h2>Bitte aktualisieren Sie Ihren Browser!</h2>').appendTo(container);

        throw 'Requirement error: Your browser does not support the following requirements: ' + _.map(errors, 'name').join(', ');
    }
}